import React from "react";

class DOMErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    const msg = error?.message || "";
    const isDOMError =
      msg.includes("removeChild") ||
      msg.includes("insertBefore") ||
      msg.includes("appendChild") ||
      msg.includes("not a child of this node") ||
      msg.includes("not a child");

    if (isDOMError) {
      console.warn("[DOMErrorBoundary] Caught and suppressed DOM cleanup error:", msg);
      return;
    }

    throw error;
  }

  render() {
    return this.props.children;
  }
}

export default DOMErrorBoundary;
